import { ERROR_TYPE } from './constants';

const validateBreakChannelTypes = (breakChannelTypes) => {
  const breakChannelTypeErrors = { errorMessage: '', rowErrors: [] };

  // NOTE: As there is always one default row, this may not be needed anymore
  if (!breakChannelTypes.length)
    return {
      ...breakChannelTypeErrors,
      errorMessage: 'At least one break pattern detail is required',
    };

  const requiredFields = ['slotPosition', 'selection'];

  for (const breakType of breakChannelTypes) {
    const item = {
      id: breakType.id,
      variable: ERROR_TYPE.NONE,
      optional: ERROR_TYPE.NONE,
      position: ERROR_TYPE.NONE,
      selection: ERROR_TYPE.NONE,
      slotPosition: ERROR_TYPE.NONE,
    };

    let hasFieldErrors = false;

    // Required-field checks — field is null, undefined, or empty string
    for (const field of requiredFields) {
      if (
        breakType[field] === null ||
        breakType[field] === undefined ||
        breakType[field] === ''
      ) {
        item[field] = ERROR_TYPE.REQUIRED;
        hasFieldErrors = true;
      }
    }

    // Business-rule checks — field is present but value is invalid
    // e.g. conflicting rows, duplicate priority values, etc.
    // TODO: assign ERROR_TYPE.INVALID to item fields here as rules are defined

    if (hasFieldErrors) {
      breakChannelTypeErrors.rowErrors.push(item);
    }
  }

  return breakChannelTypeErrors;
};

export const validateBreakPattern = (patternData) => {
  const {
    contentLevel,
    breakChannelTypes,
    default: defaultEnabled,
    versionName,
  } = patternData;

  const versionNameError = versionName ? '' : 'Pattern name is required';

  const contentLevelErrors = {
    eventType:
      contentLevel.eventType || defaultEnabled ? '' : 'Event type is required',
    eventName:
      contentLevel.eventName || defaultEnabled ? '' : 'Event name is required',
  };

  const breakChannelTypesValidation = validateBreakChannelTypes(
    breakChannelTypes,
  );

  const hasErrors =
    versionNameError ||
    Object.values(contentLevelErrors).some(Boolean) ||
    breakChannelTypesValidation.errorMessage ||
    breakChannelTypesValidation.rowErrors.length > 0;

  return {
    hasErrors,
    versionName: versionNameError,
    contentLevel: {
      eventType: contentLevelErrors.eventType,
      eventName: contentLevelErrors.eventName,
    },
    breakChannelTypes: breakChannelTypesValidation,
  };
};
